import { mapState } from 'vuex';
import AssetHandler from '@/mixins/assetHandler.js';
import TrackingHandler from '@/mixins/trackingHandler.js';

export default {
  mixins: [
    AssetHandler,
    TrackingHandler
  ],

  data: () => ({
    openedAccordion: null,
    accordions: [
      {
        id: 3,
        name: 'Serviceleistung',
        icon: 'fo-serviceleistung',
        slv_icon: 'serviceleistungen',
        description: 'Optionale Serviceleistungen',
        tracking_name: 'serviceleistung',
        items: [
          {
            name: 'RehaManager',
            text: 'Wir helfen nach einem schweren Unfall bei notwendigen medizinischen, beruflichen, technischen und pflegerischen Reha-Maßnahmen. Von der Auswahl spezifischer Fachärzte, über die Wiedereingliederung in den Beruf und/oder die notwendige Umrüstung Ihres Autos, bis hin zur Klärung des Pflegebedarfs – wir organisieren und bezahlen Hilfeleistungen. Bis 3 Jahre nach einem Unfall (bei voraussichtlicher Invalidität ab 25 Prozent).'
          },
          {
            name: 'AlltagsManager',
            text: 'Ob Kinderbetreuung, Haushaltshilfe, Gartenpflege, Menüservice, Fahrdienste oder das Unterbringen Ihrer Haustiere – wir kümmern uns um die alltäglichen Dinge, wenn Sie dazu nicht in der Lage sind, bis 6 Monate nach einem Unfall, einer ambulanten Operation oder einem stationären Krankenhausaufenthalt. Damit können Sie sich voll und ganz auf Ihre Genesung konzentrieren.'
          }
        ]
      },
      {
        id: 2,
        name: 'Ergänzungsschutz',
        icon: 'fo-krankenhaus',
        slv_icon: 'krankenhaus',
        description: 'Wichtige optionale Leistungen im Ergänzungsschutz',
        tracking_name: 'ergaenzungsschutz',
        items: [
          {
            name: 'Sofortleistung',
            text: 'Wir zahlen einmalig bei einem Oberschenkelhalsbruch und bestimmten unfallbedingten Verletzungen.'
          },
          {
            name: 'Unfall-Tagegeld',
            text: 'Wir zahlen ein Unfall-Tagegeld bei unfallbedingter Arbeitsunfähigkeit ab dem 8. oder 43. Tag für max. 1 Jahr.'
          },
          {
            name: 'Leistung bei Unfalltod',
            text: 'Wir zahlen die vereinbarte Leistung an die Bezugsberechtigten – auch bei Verschollenheit.'
          },
          {
            name: 'Krankenhaus-Tagegeld',
            text: 'Wir zahlen ein Krankenhaus-Tagegeld bei einem unfallbedingtem stationären Krankenhausaufenthalt oder einer ambulanten OP nach einem Unfall für max. 5 Jahre.'
          }
        ]
      },
      {
        id: 1,
        name: 'Kernschutz',
        icon: 'fo-unfall1',
        slv_icon: 'kranken-unfall1',
        description: 'Ausgezeichnete Leistungen im Kernschutz',
        tracking_name: 'kernschutz',
        items: [
          {
            name: 'Kapitalleistung bei Invalidität',
            text: 'Je schwerer die Folgen eines Unfalls, desto nötiger ist ein hoher finanzieller Ausgleich. Gut zu wissen, dass wir ab jedem messbaren Grad der Invalidität zahlen.'
          },
          {
            name: 'Unfallrente',
            text: 'Zahlung erfolgt ab 30, 50 oder 90 Prozent Invaliditätsgrad lebenslang oder bis zum 67. Lebensjahr – Sie entscheiden.'
          }
        ]
      }
    ]
  }),

  computed: {
    ...mapState([
      'appConfigs'
    ]),

    config() {
      return this.appConfigs[this.$options.configIndex] || {};
    },
  },

  methods: {
    openAccordion(item) {
      if (this.openedAccordion === item) {
        this.openedAccordion = null;
        return;
      }

      this.openedAccordion = item;
      this.triggerActionEvent(this.accordions[item].tracking_name, 'infografik', true);
    }
  }
};



// WEBPACK FOOTER //
// ./src/apps/private_unfallversicherung/logic.js